<template>
  <div class="mt-8">
    <vc-calendar
      :attributes="attributes"
      :columns="$screens({ default: 1, sm: 2 })"
      :rows="$screens({ default: 1, sm: 2 })"
      is-expanded
    />
  </div>
</template>

<script>
export default {
  name: 'ReservationsCalendar',
  props: {
    documents: {
      type: Array,
    },
  },
  data() {
    return {
      attributes: [],
    }
  },
  methods: {
    transformDate(date) {
      let transformedDate = null
      if (date) {
        transformedDate = new Date(date)
      }
      return transformedDate
    },
    validateDates(startDate, endDate) {
      if (!startDate) {
        return false
      }
      if (!endDate) {
        endDate = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365 * 10)
      }

      if (startDate > endDate) {
        return false
      }
      return {
        startDate,
        endDate,
      }
    },
    addDates() {
      const docs = this.documents
      const reservations = []

      for (let i = 0; i < docs.length; i += 1) {
        const type = docs[i].data.bookingtype
        const startDate = this.transformDate(docs[i].data.startdate)
        const endDate = this.transformDate(docs[i].data.enddate)
        const validation = this.validateDates(startDate, endDate)
        let popoverText = null

        if (docs[i].data.closing_reason[0]) {
          popoverText = docs[i].data.closing_reason[0].text
        }

        if (validation) {
          reservations.push({
            type,
            key: docs[i].id,
            dates: { start: validation.startDate, end: validation.endDate },
            popoverText,
          })
        }
      }

      reservations.forEach(reservation => {
        const object = {
          key: reservation.key,
          highlight: {
            color: 'red',
            fillMode: 'light',
          },
          dates: reservation.dates,
          popover: {
            label:
              reservation.popoverText ||
              'Die gesamte Unterkunft ist vermietet.',
          },
        }
        if (reservation.type === 'Einzelübernachtungen') {
          object.highlight.color = 'orange'
          object.popover.label = 'Einzelne Zimmer sind belegt.'

          if (reservation.popoverText) {
            object.popover.label = reservation.popoverText
          }
        }

        if (reservation.type === 'Geschlossen') {
          object.highlight.fillMode = 'solid'
        }

        this.attributes.push(object)
      })

      this.attributes.push({
        key: 'today',
        highlight: true,
        dates: new Date(),
        popover: {
          label: 'Heute',
        },
      })
    },
  },
  // created() {
  //   this.addDates()
  // },

  beforeMount() {
    this.addDates()
  },
}
</script>
